export const VERIFICATION_STATES = {
  VERIFIED: "VERIFIED",
  PARTIALLY_VERIFIED: "PARTIALLY_VERIFIED",
  NOT_VERIFIED: "NOT_VERIFIED",
};

export const VERIFICATION_DELAY = 1000;

export const EMPTY_FIELD = "";
